// removed by extract-text-webpack-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-GenericError-icon"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/GenericError/style.css
// module id = 392
// module chunks = 1